import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ExternalBranchesFilterEntity } from '../../domain/entities/ExternalBranchesFilterEntity'

export class ExternalBranchesFilterModel extends ExternalBranchesFilterEntity {
  constructor(dataDto: ExternalBranchesFilterEntity) {
    super()
    mapEntityProperties<ExternalBranchesFilterModel>(this, dataDto)
  }
}
